<template>
    <div class="section-otp">
        <ButtonCustom
            type="go-back"
            classBtn="section-otp__header"
            :text="text"
            :isGoBackHistory="false"
            @onClickButton="onClickGoBack"
        />

        <div class="section-otp__body">
            <p class="section-otp__description t-transform-cap">
                {{ getTranslatedText(renderDescription()) }}
            </p>
            <div class="section-otp__method-otp" v-if="!isHiddenMethodOtp">
                <span>{{ renderMethodOTP() }}</span>
                <button
                    class="section-otp__btn-edit-phone t-transform-cap"
                    @click="onClickGoBack"
                >
                    {{ getTranslatedText("edit") }}.
                </button>
            </div>

            <FormCommon
                :formItem="formItem"
                :dataForm="dataForm"
                @update-form-data="updateFormData"
                @onSubmitForm="onSubmitForm"
                @onToggleShowPassword="onToggleShowPassword"
            >
                <div slot="button">
                    <div class="section-otp__btn-resend">
                        <button
                            class="t-transform-cap"
                            type="button"
                            :disabled="isDisableResend"
                            @click="sendOTP(true)"
                        >
                            {{ getTranslatedText("resend") }}
                        </button>
                        <span>
                            {{ getTranslatedText("in") }} {{ renderNumber(timerCount) }}
                            {{ getTranslatedText("seconds") }}
                        </span>
                    </div>
                    <div class="section-otp__box-btn">
                        <ButtonCustom
                            classBtn="register-btn-close"
                            typeBtn="button"
                            type="default"
                            text="cancel"
                            @onClickButton="onClickCancel"
                        />
                        <ButtonCustom
                            :text="textBtnContinue"
                            :isLoading="isLoadingButton"
                            classBtn="register-btn-continue"
                            typeBtn="submit"
                            type="primary"
                            icon="arrow-right.png"
                        />
                    </div>
                </div>
            </FormCommon>
        </div>
    </div>
</template>
<script>
import "@/assets/scss/common/form/_form.scss";
import "@/assets/scss/mobile/authenticate/_register.scss";

import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";
import languageMixin from "@/mixins/language/language-mixin";

import { isStrEmpty, renderLocaleNumber } from "@/components/common/utils";

export default {
    mixins: [languageMixin],
    components: {
        FormCommon,
        ButtonCustom,
    },
    props: {
        text: {
            type: String,
            default: "",
        },
        textBtnContinue: {
            type: String,
            default: "set password",
        },
        dataSource: {
            type: Object,
            default() {
                return {};
            },
        },
        isHiddenMethodOtp: {
            type: Boolean,
            default: false,
        },
        isLoadingButton: {
            type: Boolean,
            default: false,
        },
        methodsChangeInfo: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            timerCount: 60,
            isDisableResend: true,
            dataForm: {
                code: "",
            },
            formItem: [
                {
                    type: "input",
                    typeInput: "password",
                    typeShow: 'password',
                    placeholder: "",
                    name: "code", 
                    required: true,
                    label: "please enter the 6 digit OTP below",
                    for: "input-code",
                    id: "input-code",
                },
            ],
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                }
                if (value === 0) {
                    this.isDisableResend = false;
                }
            },
            immediate: true,
        },
    },
    methods: {
        sendOTP(isShowNoti) {
            this.timerCount = 60;
            this.isDisableResend = true;
            this.$emit("sendOTP", isShowNoti);
        },

        onSubmitForm() {
            this.$emit("onSubmitForm", this.dataForm);
        },

        renderDescription() {
            const { email } = this.dataSource;
            let textDescription = "";
            if (!isStrEmpty(this.methodsChangeInfo) ? this.methodsChangeInfo === 'email' : !isStrEmpty(email)) {
                textDescription = this.getTranslatedText(
                    `we have sent a 6 digit number to your email`
                );
            } else {
                textDescription = this.getTranslatedText(
                    `we have sent a 6 digit number via SMS to your mobile number`
                );
            }
            return textDescription;
        },

        renderMethodOTP() {
            const { email, phone, code, calling_code } = this.dataSource;

            let textMethodRegister = "";
            if (!isStrEmpty(this.methodsChangeInfo) ? this.methodsChangeInfo === 'email' : !isStrEmpty(email)) {
                textMethodRegister = `${email}`
                // textMethodRegister = `${email
                //     .split("@")[0]
                //     .substr(0, 6)}*****@${email.split("@")[1]}`;
            } else {
                let codeFomat = !isStrEmpty(this.methodsChangeInfo) ? calling_code : code
                textMethodRegister = codeFomat+`${phone}`
                // textMethodRegister = `${
                //     !isStrEmpty(codeFomat) ? codeFomat : phone.substr(0, 2)
                // } *****${phone.substr(-3)}`;
            }

            return textMethodRegister;
        },
        updateFormData(item) {
            let { value, name } = item;
            this.dataForm[name] = value;
        },

        onClickCancel() {
            this.$emit("onClickGoBack");
        },

        onClickGoBack() {
            this.$emit("onClickGoBack");
        },

        renderNumber(number) {
            return renderLocaleNumber(parseInt(number))
        },

        onToggleShowPassword(name) {
            let index = this.formItem.findIndex(x => x.name === name)
            if(index !== -1 ) {
                this.formItem[index].typeShow = this.formItem[index].typeShow === 'password' ? 'text' : 'password'
            }
        }
    },
};
</script>

<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/authenticate/_confirm-otp.scss"
/>
